<template>
    <base-dialog :loading="loading" v-if="survey" :value="dialog" :title="surveyName" :width="520" persistent hide-close
        @input="onInput" @close="hide">
        <div class="survey-options">
            <button
                v-for="(option, i) in options" :key="i" type="button"
                class="survey-option"
                :class="{ 'survey-option--selected': optionSelected === option }"
                @click="onSelectOption(option)">
                <span class="survey-option__label">{{ option.name }}</span>
                <v-icon v-if="optionSelected === option" size="20" color="primary">mdi-check-circle</v-icon>
            </button>
        </div>
        <template #footer>
            <v-btn
                block depressed x-large color="primary"
                class="black--text text-none font-weight-bold survey-send"
                :disabled="!optionSelected" :loading="loading" @click="sendOption">
                {{ $t('common.send') }}
            </v-btn>
        </template>
    </base-dialog>
</template>

<script>
import { mapState } from "vuex";
import { db, FieldValue, Timestamp } from '../../utils/Firebase';
import BaseDialog from "@/components/common/BaseDialog";

export default {
    name: "SurveyActiveDialog",
    components: { BaseDialog },
    props: {
        exercise: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            survey: null,
            options: [],
            optionSelected: null,
        }
    },
    computed: {
        ...mapState(['currentUser']),
        surveyName(vm = this) {
            return vm.survey?.name || ''
        },
    },
    mounted() {
        const vm = this;
        vm.checkSurveyActive()
    },
    methods: {
        show() {
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onInput(val) {
            if (!val) this.hide()
        },
        async checkSurveyActive() {
            const vm = this;
            let surveyActiveRef = await db.collection('surveys').where('active', '==', true).limit(1).get();
            let survey = surveyActiveRef.docs[0] ? { id: surveyActiveRef.docs[0].id, ...surveyActiveRef.docs[0].data() } : null;

            if (survey) {
                let surveyAnswerRef = await db.collection('surveyAnswersUser').where('userId', '==', vm.currentUser.uid).where('surveyId', '==', survey.id).limit(1).get();
                if (surveyAnswerRef.empty) {
                    const optionsRef = await db.collection('surveys').doc(survey.id).collection('options').get();
                    vm.options = optionsRef.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    vm.survey = survey
                    vm.show()
                }
            }
        },
        onSelectOption(option) {
            const vm = this;
            if (vm.optionSelected === option) return vm.optionSelected = null
            vm.optionSelected = option;
        },
        async sendOption() {
            const vm = this;
            await vm.withLoading(async () => {
                await db.collection('surveyAnswersUser').add({
                    userId: vm.currentUser.uid,
                    surveyId: vm.survey.id,
                    option: vm.optionSelected.id,
                    votedAt: Timestamp.now()
                });

                await db.collection('surveys').doc(vm.survey.id).collection('options').doc(vm.optionSelected.id).update({
                    votes: FieldValue.increment(1)
                });

                vm.hide()
            })
        }
    },
}
</script>

<style scoped>
.survey-options {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.survey-option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    padding: 14px 16px;
    text-align: left;
    border-radius: 12px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline-base);
    color: var(--v-txtPrimary-base);
    cursor: pointer;
    transition: border-color 0.15s, background 0.15s;
}

.survey-option:hover {
    border-color: var(--v-outline2-base);
}

.survey-option--selected {
    border-color: var(--v-primary-base);
    background: var(--v-field-base);
}

.survey-option__label {
    font-size: var(--fs-body);
    font-weight: 500;
    word-break: break-word;
}

.survey-send {
    border-radius: 0 !important;
}
</style>
